import React, { Component } from 'react';
import SupportBase from "../common/SupportBase";

export class Training extends Component {

    render() {
        return <SupportBase
            currentUser={this.props.currentUser}
            contentName={'training'}
            title={'PROCEDURE P9.0 TRAINING'}
            exportTitle={'<h2>Procedure P9.0 Training</h2>'}
            exportFileName={'training.docx'}
            latestRevision={this.props.revision}
        />
    };
}

export default (Training);